import script from "./CartProductPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartProductPrice.vue?vue&type=script&lang=ts&setup=true"

import "./CartProductPrice.vue?vue&type=style&index=0&id=4e49dbda&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e49dbda"]])

export default __exports__